import React, { useEffect, useState } from "react";
import {
  Col,
  Skeleton,
  Input,
  ConfigProvider,
  DatePicker,
  Badge,
  Empty,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { GoCalendar } from "react-icons/go";
import { AiFillCaretRight, AiFillCaretLeft } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { getTimeSheetList } from "../../redux/actions";
import "./TimesheetList.css";
import moment from "moment";
import "moment/locale/en-gb";
import locale from "antd/es/locale/en_GB";
import TimesheetListCards from "./components/ListCards/TimesheetListCards";
import CustomCalendar from "./components/customCalendar/customCalendar";

const ManageTimeSheet = () => {
  const dayStart = moment().startOf("week");
  const daystart2 = dayStart._d.toISOString();
  const { Search } = Input;

  const weekEnd = moment().endOf("week");
  const weekEnd2 = weekEnd._d.toISOString();

  const [search, setSearch] = useState();
  const [dateSelected, setDateSelected] = useState();
  const [boolDate, setBoolDate] = useState(false);
  const [getWeek, setWeek] = useState();
  const [startDate, setStartDate] = useState(daystart2);
  const [endDate, setEndDate] = useState(weekEnd2);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  const weekFormat = "MMMM DD, YYYY";
  const dispatch = useDispatch();
  const customWeekStartEndFormat = (value) =>
    `${moment(value).startOf("week").format(weekFormat)} - ${moment(value)
      .endOf("week")
      .format(weekFormat)}`;

  const timesheet_list = useSelector(
    (state) => state.TimesheetListReducer.timesheet_list
  );
  const loading = useSelector((state) => state.TimesheetListReducer.loading);

  moment.locale("en-gb", {
    week: {
      dow: 1, /// Date offset
    },
  });

  useEffect(() => {
    dispatch(
      getTimeSheetList({
        startdate: startDate,
        enddate: endDate,
      })
    );
  }, [startDate]);

  const searchthrough = (e) => {
    const search = timesheet_list.filter((data) => {
      if (
        data.users[0].name.toLowerCase().includes(e.target.value.toLowerCase())
      ) {
        return data;
      }
    });
    setSearch(search);
  };

  const shiftCalenderRight = () => {
    var abc = moment();
    var abc2 = new Date(abc._d);
    abc2 = new Date(abc2.getFullYear(), abc2.getMonth(), abc2.getDate() + 6);
    var day = new Date(dateSelected ? dateSelected : abc2);
    const nextWeek = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate() + 7
    );
    const nextWeekShift = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate() + 2
    ).toISOString();
    const endofweek = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate() + 8
    ).toISOString();
    setDateSelected(nextWeek);
    setStartDate(nextWeekShift);
    setEndDate(endofweek);
    setWeek(nextWeek);
  };

  const shiftCalenderLeft = () => {
    setBoolDate(false);
    var abc = moment();
    // console.log('calender values to right',abc);
    var day = new Date(dateSelected ? dateSelected : abc);
    const nextWeek = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate() - 7
    );
    var enddate = nextWeek.toISOString();
    const startofweek = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate() - 13
    ).toISOString();
    setEndDate(enddate);
    setStartDate(startofweek);
    setDateSelected(nextWeek);
    setWeek(nextWeek);
  };

  const getdates = (date, dateString) => {
    setBoolDate(true);
    const firstday = dateString.split("-")[0];
    var firsday2 = new Date(firstday);
    firsday2 = new Date(
      firsday2.getFullYear(),
      firsday2.getMonth(),
      firsday2.getDate() + 1
    ).toISOString();
    // console.log('firsday',new Date(firstday.getFullYear(),firstday.getMonth(), firstday.getDate()+1));
    setStartDate(firsday2);
    var lastDay = dateString.split("-")[1];
    var lastDay2 = new Date(lastDay);
    lastDay2 = new Date(
      lastDay2.getFullYear(),
      lastDay2.getMonth(),
      lastDay2.getDate() + 1
    ).toISOString();
    setEndDate(lastDay2);
    setDateSelected(lastDay);
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Col>
      {windowDimensions.width < 700 ? (
        <div className={"searchAnDdate-div"}>
          <Col>
            <Input
              type={"input"}
              className={"search-input"}
              placeholder="Find candidates or skill listings"
              onChange={searchthrough}
              prefix={<SearchOutlined className={"search-icon"} />}
            />
          </Col>

          <Col className="mobile-date-picker-container">
            <AiFillCaretRight
              className="calender-arrow-right"
              onClick={shiftCalenderRight}
            />
            <AiFillCaretLeft
              className="calender-arrow-left"
              onClick={shiftCalenderLeft}
            />
            <div className="datepicker-div">
              <ConfigProvider locale={locale}>
                <DatePicker
                  defaultValue={moment()}
                  onChange={getdates}
                  value={boolDate ? moment(dateSelected) : moment(getWeek)}
                  suffixIcon={<GoCalendar className="calendar-icon" />}
                  format={customWeekStartEndFormat}
                  picker="week"
                  disabledDate={(current) => {
                    return moment().add(-1, "days") >= current;
                  }}
                />
              </ConfigProvider>
            </div>
          </Col>
        </div>
      ) : (
        <div>
          <div className={"manage-sheet-text"}>Manage candidate timesheet</div>
          <div className={"calender-input-container"}>
            <div className={"timesheet-input-container"}>
              <Search
                type={"search-input"}
                className="search-input"
                placeholder="Find candidates or skill listings"
                onChange={searchthrough}
                enterButton="Search"
                prefix={<SearchOutlined className="search-icon" />}
              />
            </div>
            {/*<CustomCalendar setStartdate={setStartDate} setEnddate={setEndDate}/>*/}
            <Col className="date-picker-container">
              <AiFillCaretRight
                className="calender-arrow-right"
                onClick={shiftCalenderRight}
              />
              <AiFillCaretLeft
                className="calender-arrow-left"
                onClick={shiftCalenderLeft}
              />
              <div className="datepicker-div">
                <ConfigProvider locale={locale}>
                  <DatePicker
                    defaultValue={moment()}
                    onChange={getdates}
                    value={boolDate ? moment(dateSelected) : moment(getWeek)}
                    suffixIcon={<GoCalendar className="calendar-icon" />}
                    format={customWeekStartEndFormat}
                    picker="week"
                    disabledDate={(current) => {
                      return moment().add(-1, "days") >= current;
                    }}
                  />
                </ConfigProvider>
              </div>
            </Col>
          </div>
        </div>
      )}

      <div className={"timesheet-list-cards-container"}>
        {loading ? (
          <div style={{ width: "88%", margin: "auto" }}>
            <Skeleton active={true} />
          </div>
        ) : (
          <div className={"cards-div-container"}>
            {search ? (
              search.map((items, index) => {
                return (
                  <div key={index}>
                    <TimesheetListCards {...items} />
                  </div>
                );
              })
            ) : timesheet_list.length ? (
              timesheet_list.map((items, index) => {
                return <TimesheetListCards key={index} {...items} />;
              })
            ) : (
              <Empty />
            )}
          </div>
        )}
      </div>
    </Col>
  );
};
export default ManageTimeSheet;
